import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import "./Header.css";

export default function PublicHeader({ onBook }) {
  const { user } = useAuth(); const nav=useNavigate(); const [open,setOpen]=useState(false);
  const labels = {home:"Home", portfolio:"Portfolio", gallery:"Gallery", reels:"Reels", services:"Services", blog:"Blog", about:"About", book:"Contact"};
  const links=[
    {to:"/",label:labels.home},{to:"/portfolio",label:labels.portfolio},{to:"/gallery",label:labels.gallery},
    {to:"/reels",label:labels.reels},{to:"/services",label:labels.services},{to:"/blog",label:labels.blog},{to:"/about",label:labels.about},{to:"/contact",label:labels.book}
  ];
  return <header className="public-header fixed top-0 inset-x-0 z-50">
    <div className="header-shell">
      <Link to="/" className="brand-lockup"><img src="https://customer-assets.emergentagent.com/job_shoot-schedule-5/artifacts/si4gjvxu_IMG_7223.png" alt="Wedding Touch" className="brand-logo"/><span>Wedding<span>·</span>Touch</span></Link>
      <nav className="desktop-nav">{links.map(l=><NavLink key={l.to} to={l.to} end={l.to==="/"} className="overline nav-link">{l.label}</NavLink>)}</nav>
      <div className="header-actions">
        <button className="header-book-now" onClick={onBook}>Book Now</button>
        {user?<button className="admin-link desktop-only" onClick={()=>nav('/admin')}>Dashboard</button>:<Link className="admin-link desktop-only" to="/admin/login">Admin</Link>}
        <button className="mobile-menu-btn" onClick={()=>setOpen(!open)} aria-label="Menu">{open?<X/>:<Menu/>}</button>
      </div>
    </div>
    {open && <nav className="mobile-nav">{links.map(l=><NavLink key={l.to} to={l.to} onClick={()=>setOpen(false)}>{l.label}<span>→</span></NavLink>)}<button onClick={()=>{onBook();setOpen(false)}}>BOOK YOUR DATE</button></nav>}
  </header>;
}
